<template>
    <div id="catalog">
        <div class="row">
            <div class="col-xs-12" style="padding: 3px;">
                <div v-if="showbuttons" class="row" id="static-top" style="margin: 0px;position: fixed;z-index: 9999;background: white;min-height: 60px;width:100%;top:0px; border-bottom: 1px solid #e8e7e3;">
                    <div style="margin-top: 15px;">
                        <div @click="leveldown()" v-if="current_level > 0" class="col-xs-2" style="padding-left: 20px;padding-top: 8px;">
                            <span  style="font-size: 20px;"><i class="ti-arrow-left"></i></span>
                        </div>
<!--                        <div v-else-if="demo" class="col-xs-2" style="padding-left: 20px;padding-top: 8px;">-->
<!--                            <span style="font-size: 20px;"><a href="https://webzakaz.akitorg.ru/#/catalog?exit=1"><i class="ti-unlock"></i></a></span>-->
<!--                        </div>-->
                        <div v-else  class="col-xs-2" style="padding-left: 20px;padding-top: 8px;">
                        </div>
                        <div class="col-xs-8" style="padding: 0px;">
                            <div v-if="searchactive" ifclass="col-xs-12">
                                <div class="input-group">
                                    <input type="text" value="" class="form-control" v-model="searchdata" @keyup="changesearch()"  placeholder="Поиск...">
                                    <span class="input-group-addon" v-on:click="changesearchactive(false)"><i class="ti-close"></i></span>
                                </div>
                            </div>
                            <div v-else class="col-xs-12" style="padding-left: 6px;padding-top: 5px;">
                                <div class="col-xs-10">
                                    <span>{{parentname}}</span>
                                </div>
                                <div v-on:click="changesearchactive(true)" class="col-xs-2" style="font-size: 20px;">
                                    <i class="fa fa-search"></i>
                                </div>

                            </div>
                        </div>
                        <div class="col-xs-2" style="padding-left: 6px;padding-top: 4px;">
                            <span v-if="sum > 0" style="font-size: 24px;" @click="clear_order()"><i class="ti-trash"></i></span>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin: 0;">
                    <div class="card">
                        <div class="card-content" style="margin-top: 60px;">
                            <div class="row" style="font-size: 1.5em;">
                                <div class="col-xs-4" @click="cheangetype(1)">
                                    <center>
                                        <i class="ti-align-justify"></i>
                                    </center>
                                </div>
                                <div class="col-xs-4" @click="cheangetype(2)">
                                    <center>
                                        <i class="ti-layout-accordion-separated"></i>
                                    </center>
                                </div>
                                <div class="col-xs-4" @click="cheangetype(3)">
                                    <center>
                                        <i class="ti-layout-grid2"></i>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-bottom: 100px;">
            <div v-if="typeview===1">
            <div class="row" v-for="(good) in goods_arr" v-bind:key="good.id" @click="levelup(good)">
                <hr />
                <div class="col-xs-3" @click="showSwal('input-field', good)" style="padding-left: 15px;">
                    <span v-html="photo_src(good)"></span>
                </div>
                <div class="col-xs-9" style="padding-left: 5px;">
                    <div class="row">
                        <div class="col-xs-12" style="padding-right: 3px; padding-left: 3px;">
                            <div class="td-name pull-left">{{good.name}}</div>
                        </div>
                    </div>
                    <div class="row" style="width: 100%;">
                        <div class="col-xs-6" style="padding-left: 0px;padding-right: 0;">
                            <div class="col-xs-12" style="padding-left: 0px;padding-right: 3px;">
                                <div class="td-sum">
                                    <template>
                                        {{goodPrice(good)}}
                                    </template>
                                </div>
                            </div>
                            <div class="col-xs-12" style="padding-left: 10px;padding-right: 5px;min-height: 26px;">
                                <div class="td-order">
                                    <template v-if="order.find(x => x.good === good.id)">
                                        <span class="">х {{order.find(x => x.good === good.id).quantity}} {{koef(good)}}</span>
                                    </template>
                                </div>
                            </div>
                            <div class="col-xs-10" style="padding: 0px;">
                                <div class="td-order">
                                    <template v-if="order.find(x => x.good === good.id)">
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-6" style="padding-left: 0px;padding-right: 0;">
                            <div class="col-xs-6" style="padding-left: 0px;padding-right: 0;">
                                <template v-if="good.isgroup === 0">
                                    <button class="btn btn-default" @click="remove_good(good)"><i class="ti-minus" ></i></button>
                                </template>
                            </div>
                            <div class="col-xs-6" style="padding-left: 0px;padding-right: 15px;">
                                <template v-if="good.isgroup === 0">
                                    <button class="btn btn-default" @click="add_good(good)"><i class="ti-plus" ></i></button>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="good.units.length>1">
                        <div class="col-xs-12" style="padding-right: 3px; padding-left: 3px;">
                            <drop-down>
                                <button slot="title" class="btn btn-block dropdown-toggle" data-toggle="dropdown">
                                    {{good.units.find(unit => unit.def === true).name}}
                                    <b class="caret"></b>
                                </button>
                                <li v-for="(unit) in good.units" :key="unit.uuid" v-on:click="changeUnit(good, unit)"><a>{{unit.name}}</a></li>
                            </drop-down>
                            <span v-for="(unit) in good.units" :key="unit.uuid" style="margin-right: 10px;">
                            </span>
                        </div>
                    </div>
                </div>

            </div>
            <p v-if="loadmore"> .... 🙄 ...</p>
            </div>
            <div v-if="typeview===2">
                <div class="card" style="margin-left: 10px;margin-right: 10px;" v-for="(good) in goods_arr" v-bind:key="good.id" @click="levelup(good)">
                <div v-if="good.isgroup === 0" class="card-content" >
                    <div class="row">
                        <div class="col-xs-12">
                                <span v-html="photo_src(good)"></span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="col-xs-8">{{good.name}}</div>
                            <div class="col-xs-4" style=";text-align: right">
                                <template v-if="good.price">
                                    {{good.price +  ''}}
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="col-xs-4" >
                                <template v-if="good.isgroup === 0">
                                    <button class="btn btn-default" @click="remove_good(good)"><i class="ti-minus" ></i></button>
                                </template>
                            </div>
                            <div class="col-xs-4">
                                <template v-if="order.find(x => x.good === good.id)">
                                    <span class="">х {{order.find(x => x.good === good.id).quantity}} </span>
                                </template>
                            </div>
                            <div class="col-xs-4">
                                <template v-if="good.isgroup === 0">
                                    <button class="btn btn-default" @click="add_good(good)"><i class="ti-plus" ></i></button>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="card-content" >
                    <div style="height:150px;background-color:#ff7a38;text-align: center;">
                            <span v-if="good.name.length < 18" style="font-size: 2.6em; color: white;font-family: 'Oswald', sans-serif;" >{{good.name}}</span>
                            <span v-else style="font-size: 2.6em; color: white;font-family: 'Oswald', sans-serif;" >{{good.name}}</span>
                    </div>
                </div>
            </div>
            </div>
            <div v-if="typeview===3">
                <div class="col-xs-6" v-for="(good) in goods_arr" v-bind:key="good.id" @click="levelup(good)"
                     style="padding: 2px;">
                    <div class="card" @click="showSwal('input-field', good)">
                        <div class="card-content" style="padding: 4px;">
                            <!--                    <div class="col-xs-6">-->
                            <!--                    </div>-->
                            <div v-if="good.isgroup === 0" class="card-content" style="padding: 2px;">
                                <span v-html="photo_src(good)"></span>
                            </div>
                            <div v-else class="card-content" style="padding: 2px;">
                                <div style="height:100px;background-color:#ff7a38;text-align: center;vertical-align: middle;font-family: 'Oswald', sans-serif;">
                                    <span v-if="good.name.length < 20" style="color: white;font-weight: 700; font-size: 25px;">{{good.name}}</span>
                                    <span v-else style="color: white;font-weight: 700; font-size: 23px;">{{good.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showbuttons&&sum>0" class="row" id="static-order" style="position: fixed;z-index: 9990;background: white;min-height: 0px;bottom:0px;width: 100%;">
            <div class="col-xs-12" style=" padding-left: 4%; padding-bottom: 10px;">
                <router-link to="/order">
                    <button class="btn btn-warning btn-fill btn-wd" style="height: 60px; width: 100%;" @click=""><span class="center" style="padding-left:60px; ">Корзина</span><span class="pull-right">{{sum}}</span></button>
                </router-link>
            </div>
        </div>
        <div class="row" v-if="showbuttons&&sum<=0" id="menu" style="position: fixed;z-index: 9990;background: rgba(4,7,6,0.27);height: 60px;bottom:0px;width: 100%;">
            <div class="col-xs-12" style=" padding-left: 4%; padding: 0px;border-top:1px ridge rgba(4,7,6,0.16);">
                <div class="col-xs-3" style="background: white;padding: 10px;background: #ececec">
                    <router-link to="/catalog">
                        <center>
                            <i class="ti-agenda" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Каталог</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/order">
                        <center>
                            <i class="ti-shopping-cart" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Заказ</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/orderslist">
                        <center>
                            <i class="ti-timer" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">История</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/settings">
                        <center>
                            <i class="ti-more-alt" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Ещё</span>
                        </center>
                    </router-link>
                </div>
                <!--                <div class="col-xs-2" style="background: white;padding: 5px;">-->
                <!--                    <center>-->
                <!--                        <i class="ti-clipboard" style="font-size: 20px;padding-top:6px;"></i>-->
                <!--                        <br/>-->
                <!--                        <span style="font-size: 1em;">Профиль</span>-->
                <!--                    </center>-->
                <!--                </div>-->
                <!--                <router-link to="/order">-->
                <!--                    <p>chno-to</p>-->
                <!--&lt;!&ndash;                    <button class="btn btn-warning btn-fill btn-wd" style="height: 60px; width: 100%;" @click=""><span class="center" style="padding-left:60px; ">Корзина</span><span class="pull-right">{{sum}} руб.</span></button>&ndash;&gt;-->
                <!--                </router-link>-->
            </div>
        </div>
    </div>
</template>

<script>

  import swal from 'sweetalert2'
  import loader from 'src/components/UIComponents/Custom/LoaderCustom'
  import GoodsList from './GoodsList'

  if (!Date.now) {
    Date.now = function () { return new Date().getTime() }
  }

  function sortirovka (arr) {
    arr.sort(function (a, b) {
      var nameA = a.name.toLowerCase()
      var nameB = b.name.toLowerCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0 // Никакой сортировки
    })
    arr.sort(function (a, b) {
      var nameA = a.isgroup
      var nameB = b.isgroup
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0 // Никакой сортировки
    })
    return arr
  }
  function uuidv4 () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  }

  export default {
    components: {
      loader,
      GoodsList
    },
    name: 'Catalog',
    data () {
      return {
        demo: true,
        timestamp: '',
        searchactive: false,
        typeview: 1,
        showbuttons: true,
        searchdata: '',
        message: '',
        loader: false,
        breadcrumb_arr: [{'id': 0, 'name': 'Каталог товаров', 'islevel': 1}],
        goods_arr: [],
        goods_arr2: [],
        current_level: 0,
        current_parent: [],
        parentname: 'Каталог товаров',
        order: [],
        sum: 0,
        i: 0,
        link: 'https://images.akitorg.ru/images/',
        order_tap: false,
        classPhoto: 'col-xs-3',
        scrollposition: 0,
        scrollpositionold: 0,
        goods: [],
        counter: 19,
        loadmore: false,
        distr: null
        // currentGoodUnit: {'good': 0, 'unit': 0}
      }
    },
    mounted () {
      if (localStorage.getItem('curentDist')) {
        this.distr = localStorage.getItem('curentDist')
      } else {
        this.$db.settings.toArray()
        // eslint-disable-next-line no-return-assign
          .then((x) => {
            if (x.length > 0) {
              this.distr = x[0].dbase
              localStorage.curentDist = x[0].dbase
            }
          })
      }
      this.check_demo()
      this.auto_obmen()
      this.getphotolink()
      this.load_save_order()
      this.get_goods()
      // this.currentparentname()
      window.addEventListener('scroll', () => {
        this.scrollposition = pageYOffset
      })
    },
    methods: {
      auto_obmen () {
        this.$db.settings.toArray()
          .then((set) => {
            let now = Date.now()
            let dif = now - set[0].lastconnection
            if (dif > 1800000) {
              this.$router.push({ name: 'Obmen' })
            }
          })
      },
      check_demo () {
        this.$db.settings.toArray()
          .then((set) => {
            if (set[0].dbase === '1389') {
              this.demo = true
            }
          })
      },
      log (p) {
        console.log(p)
      },
      sleep (ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms)
        })
      },
      getphotolink () {
        this.$db.settings.where({'dbase': this.distr}).toArray()
        // eslint-disable-next-line no-return-assign
          .then((x) => {
            if (x.length !== 0) {
              this.link = this.link + x[0].regcode + '/goods_photos/'
            }
          })
          .catch((e) => {
            console.log(e)
            this.message = e
          })
      },
      parent_name (name) {
        if (name.length > 20) {
          this.parentname = name.slice(0, 20) + '...'
        } else {
          this.parentname = name
        }
      },
      changesearchactive (p) {
        this.searchactive = p
        if (!p) {
          this.searchgoods('')
        }
      },
      cheangetype (type) {
        this.typeview = type
      },
      searchgoods (search) {
        if (search.length === 0) {
          this.current_level = 1
          this.current_parent = []
          this.get_goods(0)
          return
        }
        this.$db.goods.filter(good => {
          let gn = good.name.toLowerCase()
          let s = search.toLowerCase()
          if (gn.indexOf(s) + 1) {
            return true
          } else {
            return false
          }
        })
          .toArray()
          .then(t => {
            this.search_final(t)
          })
      },
      search_final (t) {
        this.goods = []
        this.goods = sortirovka(t)
        this.correctUnits(this.goods)
        this.current_level = 0
        this.counter = 0
        this.addtolist(20)
      },
      changesearch () {
        console.log(this.searchdata)
        this.searchgoods(this.searchdata)
      },
      levelup (good) {
        if (!good.isgroup) {
          return
        }
        this.get_goods(good.id)
        this.current_parent.push(good)
        this.parent_name(good.name)
        this.current_level++
      },
      leveldown () {
        let parent = this.current_parent.pop()
        this.current_level--
        if (this.current_level === 0) {
          this.get_goods(0)
          this.parentname = 'Каталог товаров'
          this.current_parent.pop()
        } else {
          // parent = this.current_parent.pop()
          this.get_goods(parent.parent)
          this.parent_name(this.current_parent[this.current_parent.length - 1].name)
        }
      },
      addtolist (count) {
        console.log('count= ' + count)
        if (this.counter === 0) {
          this.goods_arr = []
        }
        let a = true
        let goodsnoview = this.goods.length - this.counter
        if (goodsnoview <= count) {
          count = goodsnoview
          a = false
        }
        for (let i = 0; i < count; i++) {
          this.goods_arr.push(this.goods[this.counter])
          this.counter++
          this.loadmore = a
        }
        console.log('++++++++++++++++++++++++addtolist')
        console.log(this.goods_arr)
        console.log('addtolist ________________________')
      },
      get_goods (parent) {
        let vm = this
        if (!parent) {
          //, 'dist': this.dist

          this.$db.goods.where({'parent': 0}).toArray()
          // this.$db.goods.where({'islevel': 1}).toArray()
            .then((goods) => {
              if (goods.length === 0) {
                // console.log('tut')
                this.$db.goods.where({'islevel': 1}).toArray()
                  .then((goods2) => {
                    if (goods2.length !== 0) {
                      vm.goods = sortirovka(goods2)
                      this.current_level = 0
                      this.counter = 0
                      this.addtolist(20)
                    }
                  })
              } else {
                vm.goods = sortirovka(goods)
                vm.correctUnits(vm.goods)
                this.current_level = 0
                this.counter = 0
                this.addtolist(20)
              }
            })
            .catch((error) => {
              // Error 😨
              console.log('кетч33')
              console.log(error)
              if (error.response) {
                this.message = (error.response.data + error.response.status + error.response.headers)
              }
            })
            .finally((r) => {
              // console.log('finally' + r)
            })
        } else {
          // console.log('else')
          this.$db.goods.where({'parent': parent}).toArray()
            .then((goods) => {
              this.counter = 0
              this.goods = sortirovka(goods)
              vm.correctUnits(vm.goods)
              this.addtolist(20)
            })
            .catch((error) => {
              // Error 😨
              this.message = 'кетч33'
              if (error.response) {
                this.message = (error.response.data + error.response.status + error.response.headers)
              }
            })
        }
      },
      load_save_order () {
        // this.$db.order.toArray().then( x => this.order = x)
        let p = this.$db.order.toArray()
        p.then(x => {
          this.order = x
          this.order_sum()
        })
      },
      add_good (good) {
        let quantity = 1
        let unit = good.units.find(unit => unit.def === true)
        if (unit === undefined) {
          if (good.units.length === 1) {
            unit = good.units[0]
          }
        }

        // ищем в массиве запись с товаром
        let a = this.order.findIndex(x => x.good === good.id)
        // console.log('a = ' + a)
        // если найдена позиция в массиве
        if (a >= 0) {
          quantity = this.order[a].quantity
          quantity++
          let vdsum = Math.floor(quantity * good.price * 100 * unit.multiplier) / 100
          this.$set(this.order, a, {good: good.id, quantity: quantity, price: good.price, name: good.name, photo: good.photo, unit: unit.id, dsum: vdsum, multiplier: unit.multiplier, discount: 0, project: 0, info: ''})
        } else {
          // console.log(this.sumrow(good.id))
          this.order.push({good: good.id, quantity: quantity, price: good.price, name: good.name, photo: good.photo, unit: unit.id, dsum: good.price, multiplier: unit.multiplier, discount: 0, project: 0, info: ''})
        }
        this.$db.order.bulkPut(this.order)
        this.order_sum()
      },
      set_q (good, q) {
        var dsum = Math.floor(q * good.price * 100) / 100
        var b = this.order.findIndex(x => x.good === good.id)
        if (b >= 0) {
          this.$set(this.order, b, {good: good.id, quantity: q, price: good.price, name: good.name, photo: good.photo, unit: 0, dsum: dsum, multiplier: 1, discount: 0, project: 0, info: ''})
        } else {
          this.order.push({good: good.id, quantity: q, price: good.price, name: good.name, photo: good.photo, unit: 0, dsum: dsum, multiplier: 1, discount: 0, project: 0, info: ''})
        }
        this.$db.order.bulkPut(this.order)
        this.order_sum()
      },
      remove_good (good) {
        let unit = good.units.find(unit => unit.def === true)
        if (unit === undefined) {
          if (good.units.length === 1) {
            unit = good.units[0]
          }
        }
        // this.scrollToTop()
        var a = this.order.findIndex(x => x.good === good.id)
        if (a >= 0) {
          var quantity = this.order[a].quantity
          if (quantity > 1) {
            quantity--
            let vdsum = Math.floor(quantity * good.price * 100 * unit.multiplier) / 100
            this.$set(this.order, a, {good: good.id, quantity: quantity, price: good.price, name: good.name, photo: good.photo, unit: unit.id, dsum: vdsum, multiplier: unit.multiplier, discount: 0, project: 0, info: ''})
          } else {
            this.order.splice(a, 1)
            this.$db.order.where('good').equals(good.id).delete()
          }
        } else {
          return
        }
        this.$db.order.bulkPut(this.order)
        this.order_sum()
      },
      order_sum () {
        var itog = 0
        this.order.forEach(function (item) {
          itog = itog + item.price * item.quantity * item.multiplier
        })
        itog = Math.floor(itog * 100) / 100
        this.sum = itog
        return itog
      },
      sumrow (goodid) {
        return Math.floor(this.order.find(x => x.good === goodid).quantity * this.order.find(x => x.good === goodid).price * 100) / 100
      },
      refresh: function () {
        this.get_goods(this.current_level)
      },
      photo_src: function (good) {
        if (good.isgroup) {
          this.classPhoto = 'col-xs-2'
          return '<i class="ti-folder" style="font-size:2.3rem;"></i>'
          // eslint-disable-next-line eqeqeq
        } else if (good.photo != '' & good.photo.length > 4) {
          this.classPhoto = 'col-xs-3'
          return '<img src="' + this.link + good.photo + '" alt="..." width="100%" height="100%"/><span style="min-height: 90px;width: 1px;"></span>'
        } else {
          if (this.typeview === 1) {
            return '<i class="ti-image" style="font-size:4rem;"></i><span style="min-height: 90px;width: 1px;"></span>'
          }
          if (this.typeview === 2) {
            return '<div style="height:150px;background-color:rgba(0,206,86,0.84);text-align: center;font-family: \'Oswald\', sans-serif;">' +
              '<span style="font-size: 1.6em; color: white;" >' + good.name + '</span>' +
              '</div>'
          }
          if (this.typeview === 3) {
            return '<div style="height:100px;background-color:rgba(0,206,86,0.84);text-align: center;vertical-align: middle;font-family: \'Oswald\', sans-serif;">' +
              '<span style="font-size: 1.2em; color: white;" >' + good.name + '</span>' +
              '</div>'
          }
        }
      },
      getSummaries (param) {
        const {columns} = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'Total'
          } else if (index < columns.length - 1) {
            sums[index] = ''
          } else {
            let sum = 0
            this.productsTable.forEach((obj) => {
              sum += obj.quantity * obj.price
            })
            sums[index] = `€ ${sum}`
          }
        })
        return sums
      },
      showSwal (type, good) {
        // $(document).foundation()
        if (good.isgroup) {
          return
        }
        // alert('well')
        var quantity = 0
        var photo = ''
        if (this.order.find(x => x.good === good.id) === undefined) {
          quantity = ''
          // console.log('quantity = ' + quantity)
        } else {
          quantity = this.order.find(x => x.good === good.id).quantity
        }
        if (good.photo !== '' && good.photo.length > 4) {
          // photo = '<i class="ti-image" style="font-size:3rem;"></i>'
          photo = '<img src="' + this.link + good.photo + '" alt="..." style="width: 80%; height: 80%;">'
        } else {
        }
        this.showbuttons = false
        swal({
          backdrop: false,
          title: good.name,
          html: '<div class="form-group">' +
            photo + '<p>' + good.price + '' + '</p>' +
            '</div>',
          input: 'number',
          inputValue: quantity,
          inputPlaceholder: 'Введите количество',
          showCloseButton: true
        }).then((result) => {
          if (result > 0) {
            this.set_q(good, result)
          } else if (result === '0' | result === '') {
            // console.log('else ' + result)
            this.dellgood(good.id)
          }
        })
          .catch((x) => {
            // console.log(x)
          })
          .finally((x) => {
            this.showbuttons = true
          })
      },
      dellgood (goodid) {
        // console.log('dellgood' + goodid)
        var a = this.order.findIndex(x => x.good === goodid)
        // console.log('a = ' + a)
        this.order.splice(a, 1)
        this.$db.order.where('good').equals(goodid).delete()
        this.order_sum()
      },
      clear_order () {
        this.currentGoodUnit = {'good': 0, 'unit': 0}
        // console.log(t)
        swal({
          title: 'Точно удалить весь заказ?',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then((result) => {
          if (result) {
            // console.log(result)
            this.order = []
            this.$db.order.clear()
            this.order_sum()
            this.order_tap = false
          }
          // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
          // console.log(error)
        })
      },
      show_order () {
        this.order_tap = true
      },
      correctUnits (goods) {
        for (let i = 0; i < goods.length; i++) {
          for (let a = 0; a < goods[i].units.length; a++) {
            goods[i].units[a].uuid = uuidv4()
            goods[i].units[a].def = false
            if (this.order.find(item => item.good === goods[i].id)) {
              let orderUnitId = this.order.find(item => item.good === goods[i].id).unit
              if (goods[i].units[a].id === orderUnitId) {
                goods[i].units[a].def = true
              }
            } else {
              if (goods[i].units[a].id === 0) {
                goods[i].units[a].def = true
              }
            }
          }
        }
      },
      changeUnit (good, unit) {
        for (let i = 0; i < good.units.length; i++) {
          if (good.units[i].id === unit.id) {
            good.units[i].def = true
          } else {
            good.units[i].def = false
          }
          good.units[i].uuid = uuidv4()
        }
        this.$forceUpdate()
        let a = this.order.findIndex(x => x.good === good.id)
        if (a >= 0) {
          let quantity = this.order[a].quantity
          let vdsum = Math.floor(quantity * good.price * 100 * unit.multiplier) / 100
          this.$set(this.order, a, {good: good.id, quantity: quantity, price: good.price, name: good.name, photo: good.photo, unit: unit.id, dsum: vdsum, multiplier: unit.multiplier, discount: 0, project: 0, info: ''})
          this.$db.order.bulkPut(this.order)
        }
        this.order_sum()
      },
      goodPrice (good) {
        if (good.isgroup === 1) {
          return ''
        }
        let price = good.price
        for (let i = 0; i < good.units.length; i++) {
          if (good.units[i].def === true) {
            price = Math.round(good.units[i].multiplier * good.price * 100) / 100
          }
        }
        return price
      },
      koef (good) {
        let r = 1
        if (good.units.length > 1) {
          r = good.units.find(unit => unit.def === true).multiplier
        }

        if (good.units.length === 1) {
          r = good.units[0].multiplier
        }

        if (r !== 1) {
          return '(x' + r + ')'
        } else {
          return ''
        }
      }
    },
    watch: {
      scrollposition () {
        if ((this.scrollposition - this.scrollpositionold) > 10) {
          this.addtolist(10)
        }
      }
    }}

</script>

<style scoped>
    .td-actions{
        width: 6rem;
    }
    .td-order{
        font-size: 1.8rem;
        min-width: 90px;
        padding-right: 20px;
        color: #5cb85c;
        font-weight: 600;
    }
    .img-container{
        padding-left: 25px;
        width: 100%;
    }
    .td-name{
        font-size:1.3rem;
        margin-right: 2rem;
    }
    .td-number{
        font-size: 1.4rem;
        color: #484541;
    }
    .td-sum{
        font-size: 1.6rem;
        min-width: 90px;
        color: #484541;
        font-weight: 600;
    }
    .row{
        margin: 0px;
    }
    hr{
        margin: 8px;
    }
    img{
        min-width: 100px;
    }
    /*.row{*/
    /*}*/
    /*body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) { overflow-y: visible !important; }*/
    body.swal2-shown {
        position: static;
    }

    a {
        color: #000000;
    }

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Custom/Catalog.vue